module.exports = __webpack_public_path__ + "assets/word_home_default.6188dc66.svg";